import { DefaultDirections, SortProviderProps, UrlSortProvider } from '@tableau/data-catalog-shared';
import * as React from 'react';

import { VirtualConnectionOrderField, OrderDirection } from '../../../../gen-src/queries/globalTypes';

export type VirtualConnectionsValidSortFields =
  VirtualConnectionOrderField.NAME |
  VirtualConnectionOrderField.DOWNSTREAM_DATASOURCES_COUNT |
  VirtualConnectionOrderField.DOWNSTREAM_WORKBOOKS_COUNT |
  VirtualConnectionOrderField.IS_CERTIFIED |
  VirtualConnectionOrderField.CONTAINER_NAME;


export const VirtualConnectionsDefaultDirections: DefaultDirections<VirtualConnectionsValidSortFields> = {
  [VirtualConnectionOrderField.NAME]: OrderDirection.ASC,
  [VirtualConnectionOrderField.DOWNSTREAM_DATASOURCES_COUNT]: OrderDirection.DESC,
  [VirtualConnectionOrderField.DOWNSTREAM_WORKBOOKS_COUNT]: OrderDirection.DESC,
  [VirtualConnectionOrderField.IS_CERTIFIED]: OrderDirection.DESC, // Certified items at the top
  [VirtualConnectionOrderField.CONTAINER_NAME]: OrderDirection.ASC,
};

export const VirtualConnectionsDefaultSortField = VirtualConnectionOrderField.DOWNSTREAM_WORKBOOKS_COUNT;

export function VirtualConnectionsGridSortProvider(
  props: Pick<SortProviderProps<VirtualConnectionsValidSortFields>, 'children'>
): JSX.Element {
  return (
    <UrlSortProvider<VirtualConnectionsValidSortFields>
      validOrderFieldsWithDefaultDirections={VirtualConnectionsDefaultDirections}
      defaultField={VirtualConnectionsDefaultSortField}
    >
      {props.children}
    </UrlSortProvider>
  );
}
